/** Menu entries for the "expand config" side panel */
export const STYLES_FIELD: any[] = [
  { title: 'dieu_chinh_noi_dung', index: 1 },
  { title: 'dieu_chinh_vien', index: 2 },
  { title: 'hieu_ung', index: 3 },
  { title: 'nang_cao', index: 4 },
  { title: 'nen_bieu_tuong', index: 5 },
];

/** Translatable text fields for the booking management area, grouped by section */
export const BOOKING_CONTENT_SECTIONS: any[] = [
  {
    title: 'dang_nhap',
    fields: [{ label: 'noi_dung_bao_dang_nhap', key: 'text_login' }],
  },
  {
    title: 'tieu_de_tab',
    fields: [
      { label: 'tab_thong_tin_ca_nhan', key: 'text_tab_personal' },
      { label: 'tab_dat_phong', key: 'text_tab_bookings' },
      { label: 'tab_hoan_tien', key: 'text_tab_refund' },
    ],
  },
  {
    title: 'tieu_de',
    fields: [
      { label: 'tieu_de_thong_tin_ca_nhan', key: 'text_title_personal' },
      { label: 'tieu_de_dat_phong', key: 'text_title_bookings' },
      { label: 'tieu_de_hoan_tien', key: 'text_title_refund' },
    ],
  },
  {
    title: 'mo_ta',
    fields: [
      { label: 'mo_ta_thong_tin_ca_nhan', key: 'text_desc_personal' },
      { label: 'mo_ta_dat_phong', key: 'text_desc_bookings' },
    ],
  },
  {
    title: 'nut_bam',
    fields: [
      { label: 'nut_luu', key: 'text_btn_save' },
      { label: 'nut_doi_mat_khau', key: 'text_btn_change_password' },
      { label: 'nut_chi_tiet', key: 'text_btn_detail' },
      { label: 'nut_xem_chi_tiet', key: 'text_btn_view_detail' },
    ],
  },
  {
    title: 'nhan_form',
    fields: [
      { label: 'ho_va_ten', key: 'text_label_name' },
      { label: 'email', key: 'text_label_email' },
      { label: 'dien_thoai', key: 'text_label_phone' },
      { label: 'dia_chi', key: 'text_label_address' },
      { label: 'mat_khau_hien_tai', key: 'text_label_current_password' },
      { label: 'mat_khau_moi', key: 'text_label_new_password' },
      { label: 'xac_nhan_mat_khau_moi', key: 'text_label_confirm' },
    ],
  },
  {
    title: 'cot_bang',
    fields: [
      { label: 'tham_chieu', key: 'text_col_bill_code' },
      { label: 'ngay', key: 'text_col_date' },
      { label: 'tong_cong', key: 'text_col_total' },
      { label: 'trang_thai', key: 'text_col_status' },
      { label: 'hoa_don', key: 'text_col_invoice' },
      { label: 'thao_tac', key: 'text_col_action' },
      { label: 'don_hang', key: 'text_col_order' },
      { label: 'tong_so_phong', key: 'text_col_total_rooms' },
      { label: 'trang_thai_hoan_tien', key: 'text_col_refund_status' },
      { label: 'ngay_yeu_cau', key: 'text_col_request_date' },
      { label: 'phong', key: 'text_col_room' },
      { label: 'loai_phong', key: 'text_col_room_type' },
      { label: 'thoi_luong', key: 'text_col_duration' },
      { label: 'gia_phong', key: 'text_col_room_price' },
      { label: 'gia_dich_vu', key: 'text_col_service_price' },
      { label: 'so_tien_hoan', key: 'text_col_refund_amount' },
    ],
  },
  {
    title: 'chi_tiet_dat_phong',
    fields: [
      { label: 'tieu_de_chi_tiet_dat_phong', key: 'text_booking_detail_title' },
      { label: 'ma_don_hang', key: 'text_booking_ref' },
      { label: 'ngay_dat', key: 'text_booked_on' },
      { label: 'chi_tiet_khach_san', key: 'text_hotel_detail' },
      { label: 'chi_tiet_chinh_sach_hoan_tien', key: 'text_refund_policy_detail' },
      { label: 'yeu_cau_huy', key: 'text_cancel_request' },
      { label: 'ten_khach_san', key: 'text_hotel_name' },
      { label: 'dien_thoai', key: 'text_phone' },
      { label: 'email', key: 'text_email' },
      { label: 'dang_xu_ly_huy', key: 'text_cancel_processing' },
      { label: 'phong_dang_xu_ly', key: 'text_rooms_processing' },
      { label: 'bam_vao_day', key: 'text_click_here' },
    ],
  },
  {
    title: 'chi_tiet_loai_phong',
    fields: [
      { label: 'chi_tiet_loai_phong', key: 'text_room_detail' },
      { label: 'ngay_nhan_phong', key: 'text_checkin' },
      { label: 'ngay_tra_phong', key: 'text_checkout' },
      { label: 'phong', key: 'text_rooms' },
      { label: 'khach', key: 'text_guests' },
      { label: 'dich_vu_them', key: 'text_extra_services' },
      { label: 'tong_tien', key: 'text_total_price' },
      { label: 'phong_da_huy', key: 'text_room_canceled' },
    ],
  },
  {
    title: 'chi_tiet_thanh_toan',
    fields: [
      { label: 'chi_tiet_thanh_toan', key: 'text_payment_detail' },
      { label: 'phuong_thuc_thanh_toan', key: 'text_payment_method' },
      { label: 'vi_tri_khach_san', key: 'text_hotel_location' },
      { label: 'dia_chi', key: 'text_address' },
      { label: 'tong_quan_thanh_toan', key: 'text_payment_summary' },
      { label: 'tong_tien_phong', key: 'text_room_cost' },
      { label: 'tong_thue', key: 'text_total_tax' },
      { label: 'thong_tin_khach', key: 'text_guest_info' },
      { label: 'ten_khach', key: 'text_guest_name' },
    ],
  },
  {
    title: 'chi_tiet_hoan_tien',
    fields: [
      { label: 'tieu_de_chi_tiet_hoan_tien', key: 'text_refund_detail_title' },
      { label: 'don_hang', key: 'text_col_order' },
      { label: 'tong_so_phong', key: 'text_col_total_rooms' },
      { label: 'trang_thai_hoan_tien', key: 'text_col_refund_status' },
      { label: 'ngay_yeu_cau_hoan_tien', key: 'text_col_request_date' },
      { label: 'phong', key: 'text_col_room' },
      { label: 'loai_phong', key: 'text_col_room_type' },
      { label: 'thoi_luong', key: 'text_col_duration' },
      { label: 'gia_phong', key: 'text_col_room_price' },
      { label: 'gia_dich_vu', key: 'text_col_service_price' },
      { label: 'so_tien_hoan', key: 'text_col_refund_amount' },
      { label: 'trang_thai_hoan_tien_hien_tai', key: 'text_current_refund_status' },
      { label: 'loai_thanh_toan', key: 'text_payment_type' },
      { label: 'tong_tien_don_hang', key: 'text_total_order' },
      { label: 'so_tien_da_hoan', key: 'text_refunded_amount' },
    ],
  },
  {
    title: 'trang_thai_tai_du_lieu',
    fields: [
      { label: 'dang_tai_dat_phong', key: 'text_loading_bookings' },
      { label: 'khong_co_dat_phong', key: 'text_empty_bookings' },
      { label: 'dang_tai_hoan_tien', key: 'text_loading_refunds' },
      { label: 'khong_co_hoan_tien', key: 'text_empty_refunds' },
    ],
  },
  {
    title: 'thong_bao_loi_form',
    fields: [
      { label: 'loi_thieu_ten', key: 'text_error_name_required' },
      { label: 'loi_thieu_email', key: 'text_error_email_required' },
      { label: 'loi_email_khong_hop_le', key: 'text_error_email_invalid' },
      { label: 'loi_thieu_sdt', key: 'text_error_phone_required' },
      { label: 'loi_sdt_khong_hop_le', key: 'text_error_phone_invalid' },
      { label: 'loi_thieu_dia_chi', key: 'text_error_address_required' },
      { label: 'loi_thieu_mat_khau_hien_tai', key: 'text_error_current_password_required' },
      { label: 'loi_thieu_mat_khau_moi', key: 'text_error_new_password_required' },
      { label: 'loi_mat_khau_khong_trung_khop', key: 'text_error_password_mismatch' },
    ],
  },
];